import React, {useState} from 'react';
import {Link} from "react-router-dom";

import CountryFlagAndName from '../../components/countryFlagAndName.js'
import DomainIcon from '../../components/domainIcon.js'
import DomainHistory from '../../components/domainHistory.js'
import DomainTechnologies from '../../components/domainTechnologies.js'
import SectionHeader from '../../components/sectionHeader.js'
import TechnologyVersionRef from '../../components/technologyVersionRef.js'
import TechnologyVersionWithScore from '../../components/technologyVersionWithScore.js'
import TechnologyIconAndName from '../../components/technologyIconAndName.js' 
import AuthLock from '../../components/authLock.js'
import CopyLink from '../../components/copyLink.js'
import CveTitle from '../../components/cveTitle.js'

import {_printDate, _printShortDate,_printNumber, _printDomainRank, _extractSocialMediaSlug} from '../../helpers/helpers.js'
import imageOnError from '../../helpers/imgOnError.js';
import UserError from '../../components/userError.js';

import {RtSocialMediaLink, RtDomainCVE, RtHeaderInfo, RtResponseHeadersSection, WebsiteInfoPageResult} from '../../../../server/routes/website.js'

interface WebsiteProps {
	server: string;
	pageData: unknown;
}

interface ComponentProps {
	props: WebsiteInfoPageResult;
}

export default function Website({server, pageData}: WebsiteProps) {

    let [data, setData] = useState(pageData as WebsiteInfoPageResult);
    
	return (
		<>
            <section className="section section-sm">
               <div className="container">
                    <div className="row row-50">
                        <div className="col-md-8 col-lg-8 col-xl-8">
                            <WebsiteLeftPanel props={data} />                   
                        </div>
                        <div className="col-md-4 col-lg-4 col-xl-4">
                            <WebsiteRightPanel props={data} />
                        </div>
                    </div>
                    <SecurityStats cves={data.DomainCVEs} link={data.CanonicalURL!}/>
                    <WebsiteBottomPanel props={data} />
                </div>
            </section>
		</>
	)
};

function WebsiteRedirectsToRow({props}: ComponentProps) {

    if (!props.RedirectsTo) return (<></>);

    return (
        
        <tr>
            <td>
                <img   
                    width="16"
                    height="16"
                    src={`https://www.google.com/s2/favicons?domain=${props.Domain}`} 
                    onError={imageOnError}
                />
                {' '}
                {props.Domain} redirects to
            </td>
            <td>
                <Link 
                    to={`/website/${props.RedirectsTo}`} 
                    className="link-hover" 
                    title={`${props.RedirectsTo} information and technology stack`}
                >
                    <b>
                        <img           
                            width="16"
                            height="16"
                            src={`https://www.google.com/s2/favicons?domain=${props.RedirectsTo}`} 
                            title={props.RedirectsTo} 
                            onError={imageOnError}
                        />
                        {' '}
                        {props.RedirectsTo}
                    </b>
                </Link>
            </td>
        </tr>
    )
}

function WebsiteDomainForwardingRow({props}: ComponentProps) {

    if (!props.RedirectedFrom) return (<></>)

    return (

        <tr>
            <td>
                Domain Forwarding
            </td>
            <td>
                {
                    !!props.RedirectedFrom.Count ?
                    <>
                        <Link 
                            to={`/website/${props.Domain}/redirects`} 
                            className="link-hover" 
                            title={`Domains that redirect to ${props.Domain}`}
                        >
                            <b>
                                {_printNumber(props.RedirectedFrom.Count)}
                            </b>
                            {
                                props.RedirectedFrom.Count === 1 ? 
                                <>website redirects</>:
                                <>websites redirects</>
                            }               
                        </Link><AuthLock /> to {props.Domain}
                    </>:
                    <>
                        There are no websites that redirect to {props.Domain}
                    </>
                }
            </td>
        </tr>
    )
}

function WebsiteLeftPanel({props}: ComponentProps) {

    const warning = ((props.SubdomainTechnologyCount / props.TechnologiesDetected) > 1.05) ? 
`Note: This page displays technologies detected on <b>${props.Domain}</b> subdomain only.\n
To view technologies identified across all subdomains of the <b>${props.SecondLevelDomain}</b> domain,\n
please refer to the <a class='link-hover' href='/website/${props.SecondLevelDomain}/aggregated'><b>Aggregated View</b></a>.` : ``;

    return (<>

        <h2 className="word-break">
            <img 
                width="16"
                height="16" 
                src={`https://www.google.com/s2/favicons?domain=${props.Domain}`} 
                onError={imageOnError}
            />
                {' '}{props.Domain}
            {/* No <Link>! this is external reference 
            <a 
                target="_blank" 
                rel="noopener nofollow noreferrer" 
                href={`http://${props.Domain}/`}
            >
                {' '}
                <span 
                    className="icon text-right fa fa-external_link">
                </span>                       
            </a>
            */}
        </h2> website information and technology stack

        <div className="row row-50">
            <div className="col-12">
                <UserError message={warning}/>               
                <table className="word-break table-custom table-custom-striped table-custom-primary">
                    <tbody>
                        <tr>
                            <td>Web technologies detected on this domain</td>
                            <td>
                                <Link 
                                    to= {`/website/${props.Domain}/technologies`} 
                                    className="link-hover" 
                                >
                                    <b>{props.TechnologiesDetected}</b>
                                </Link>  
                                {' '}
                                {   
                                    props.TechnologiesDetected === 1 ?
                                    <>technology</>:
                                    <>technologies</>
                                } <AuthLock />
                            </td>
                        </tr>
                        <tr>
                            <td>Web technologies detected across all{' '} 
                                <b>{props.SecondLevelDomain}</b> {' '}subdomains
                            </td>
                            <td>
                                <span className="icon text-primary">
                                    <Link 
                                        to={`/website/${props.SecondLevelDomain}/aggregated`} 
                                        className="link-hover" 
                                        title={`${props.SecondLevelDomain} technologies`}
                                    >
                                        <b>
                                            {props.SubdomainTechnologyCount}
                                        </b>
                                    </Link>
                                </span>
                                {' '}
                                {
                                    props.SubdomainTechnologyCount === 1?
                                        <>technology</>:
                                        <>technologies</>
                                } <AuthLock />
                            </td>
                        </tr>
                        {
                            (props.AdvertisersDetected>0) &&
                            <tr>
                                <td>Advertisers detected on this domain</td>
                                <td>
                                    <Link 
                                        to= {`/website/${props.Domain}/advertisers`} 
                                        className="link-hover" 
                                    >
                                        <b>{props.AdvertisersDetected}</b>
                                    </Link>  
                                    {' '}
                                    {   
                                        props.AdvertisersDetected === 1 ?
                                        <>technology</>:
                                        <>technologies</>
                                    }
                                </td>
                            </tr>                              
                        }
                      
                        <WebsiteRedirectsToRow props={props}/>
                        <tr>
                            <td>Website rank</td>
                            <td>
                                <span className="icon text-primary">
                                    <b>{_printNumber(props.Rank)}</b>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>Website Location</td>
                            <td>
                                <b>
                                    <CountryFlagAndName countryCode={props.HostingCountry}/>
                                </b>
                            </td>
                        </tr>      
       
                        <tr>
                            <td>Language</td>
                            <td><b>{props.Language}</b></td>
                        </tr>
                        <WebsiteDomainForwardingRow props={props}/>
                        {
                            props.TechnologyChangesSummary &&
                            <tr>
                                <td>Last technology update</td>
                                <td><b>{_printDate(props.TechnologyChangesSummary.LastUpdatedDate)}</b></td>
                            </tr>
                        }
                        {
                            props.TechnologyChangesSummary && 
                            <>
                            {
                                // TODO: AA: I never seen this info on website
                                !!props.TechnologyChangesSummary.TechnologiesAdded &&
                                <tr>
                                    <td>Added technologies in the last 3 months</td>
                                    <td>
                                        <Link 
                                            to={`/website/${props.Domain}/history`}
                                            className="link-hover" 
                                            title={`Technology stack change history for ${props.Domain}`}
                                        >
                                            <b>{props.TechnologyChangesSummary.TechnologiesAdded}</b>
                                        </Link><AuthLock />
                                    </td>
                                </tr>
                            }
                            {
                                // TODO: AA: I never seen this info on website
                                !!props.TechnologyChangesSummary.TechnologiesDropped &&
                                    <tr>
                                        <td>Dropped technologies in the last 3 months</td>
                                        <td>
                                            <Link 
                                                to={`/website/${props.Domain}/history`}
                                                className="link-hover" 
                                                title={`Technology stack change history for ${props.Domain}`}
                                            >
                                                <b>
                                                    {props.TechnologyChangesSummary.TechnologiesDropped}
                                                </b> 
                                            </Link><AuthLock />
                                        </td>
                                    </tr>
                            }
                            </>
                        }
                        {
                            !!props.Subdomains.Count &&
                            <>
                                <tr>
                                    <td>Total {props.SecondLevelDomain} subdomain count</td>
                                    <td>
                                        <Link 
                                            to={`/website/${props.SecondLevelDomain}/subdomains`} 
                                            className="link-hover" 
                                            title={`${props.SecondLevelDomain} subdomain list`}
                                        >
                                            <b>{props.Subdomains.Count}</b>
                                            {' '}
                                            {
                                                props.Subdomains.Count === 1 ?
                                                <>subdomain</>:
                                                <>subdomains</>
                                            }  
                                        </Link><AuthLock />
                                    </td>
                                </tr>
                                <tr>
                                    <td>Top ranking subdomain</td>
                                    <td>
                                        <img 
                                            width="16"
                                            height="16"
                                            src={`https://www.google.com/s2/favicons?domain=${props.Subdomains.TopRankingSubdomain!.Domain}`} 
                                            onError={imageOnError}
                                        />
                                        {' '}
                                        <Link 
                                            to={`/website/${props.Subdomains.TopRankingSubdomain!.Domain}`} 
                                            className="link-hover word-break" 
                                            title={`${props.Subdomains.TopRankingSubdomain!.Domain} information and technology stack`}
                                        >
                                            <b>
                                                {props.Subdomains.TopRankingSubdomain!.Domain}
                                            </b>
                                        </Link>
                                        {' '}
                                        (Rank: <b>{_printDomainRank(props.Subdomains.TopRankingSubdomain!.Rank, false)}</b>)
                                    </td>
                                </tr>
                            </>
                        }
                        {
                            props.IPAddress &&
                            <tr>
                                <td>IP Address</td>
                                <td>
                                    <Link 
                                        to={`/ip/${props.IPAddress}`} 
                                        className="link-hover" 
                                        title={`Reverse IP for ${props.IPAddress}`}
                                    >
                                        <b>
                                            {props.IPAddress}
                                        </b>
                                    </Link>
                                </td>
                            </tr>
                        }
                        {
                            props.IPSharedDomains &&
                            <tr>
                                <td>Reverse IP</td>
                                <td>
                                    <Link 
                                        to={`/ip/${props.IPAddress}`} 
                                        className="link-hover" 
                                        title={`Reverse IP for ${props.IPAddress}`}
                                    >
                                        <b>
                                            {_printNumber(props.IPSharedDomains)}
                                        </b> websites
                                    </Link> share{' '}
                                    <Link 
                                        to={`/ip/${props.IPAddress}`} 
                                        className="link-hover" 
                                        title={`Reverse IP for ${props.IPAddress}`}
                                    >
                                        <b>{props.IPAddress}</b>
                                    </Link>
                                    {' '}IP address.
                                </td>
                            </tr>
                        }
                        {
                            props.DomainInfo.ASNId &&
                            <tr>
                                <td>Autonomous System Number (ASN)</td>
                                <td className="word-break">
                                    <Link 
                                        to={`/asn/${props.DomainInfo.ASNId}`} 
                                        className="link-hover" 
                                        title={`ASN AS${props.DomainInfo.ASNId} ${props.DomainInfo.ASNName}`}
                                    >
                                        <b>AS{props.DomainInfo.ASNId} ({props.DomainInfo.ASNName})</b>
                                    </Link>
                                </td>
                            </tr>
                        }
                        {
                            props.BackLinks &&
                            <tr>
                                <td>Total linking domains</td>
                                <td>
                                    <span className="icon text-primary">
                                        <Link 
                                            to={`/website/${props.Domain}/backlinks`} 
                                            className="link-hover" 
                                            title="List of linking domains and IPs"
                                        >
                                            {_printNumber(props.BackLinks.DomainCount)} domains  
                                        </Link><AuthLock />
                                    </span>
                                </td>
                            </tr>
                        }
                        {
                            props.BackLinks && props.BackLinks.IPCount > 0 &&
                            <tr>
                                <td>Total linking IP</td>
                                <td>
                                    <span className="icon text-primary">
                                        <Link 
                                            to={`/website/${props.Domain}/backlinks`} 
                                            className="link-hover" 
                                            title="List of linking domains and IPs"
                                        >
                                            {_printNumber(props.BackLinks.IPCount)} IPs  
                                        </Link><AuthLock />
                                    </span>
                                </td>
                            </tr>
                        }
                        {
                            props.DomainInfo.CertIssuer &&
                            <tr>
                                <td>Certificate Issuer</td>
                                <td>
                                    <b>{props.DomainInfo.CertIssuer}</b>
                                </td>
                            </tr>
                        }
                        {
                            props.DomainInfo.CertExpiration && !props.Warnings.Unreliable &&
                            <tr>
                                <td>Certificate Expiration Date</td>
                                <td>
                                    <b>{_printDate(props.DomainInfo.CertExpiration)}</b>
                                    {
                                        props.Warnings.ExpiredCertificate &&
                                        <>
                                            {' '}(Expired <span className="icon fas fa-exclamation-triangle" style={{color: 'red'}}></span>)
                                            <br />
                                        </>
                                    }
                                    {
                                        props.Warnings.ExpiringCerticate &&
                                        <>
                                            {' '}(Expiring soon <span className="icon mdi mdi-alarm" style={{color: 'red'}}></span>)
                                        </>
                                    }
                                    {
                                        props.Warnings.ValidCertificate &&
                                        <>
                                            {' '}(Valid <span className="icon mdi mdi-checkbox-marked-circle" style={{color: 'green'}}></span>)
                                        </>
                                    }
                                </td>
                            </tr>
                        }
                        {
                            props.Tags &&
                            <tr>
                                <td>Tag IDs</td>
                                <td className="word-break">
                                    { 
                                        props.Tags.map((tag, index) => 
                                            <TagId tag={tag} key={index} index={index} />
                                        )
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>    
    </>)
}

function AvailableReports({props}: ComponentProps) {
    const aggregatedNeeded = props.SubdomainTechnologyCount > props.TechnologiesDetected;

    return (<>
            <h4>Available Reports</h4>
            <div>
                <ul>
                    {
                        props.TechnologiesDetected &&
                        <li>
                            <Link 
                                to={`/website/${props.Domain}/technologies`} 
                                className="link-hover" 
                                title={`Technology stack for ${props.Domain}`}
                            >
                                Technology Stack 
                            </Link><AuthLock />
                        </li>
                    }
                    {
                        !!aggregatedNeeded &&
                        <Link 
                            to={`/website/${props.SecondLevelDomain}/aggregated`} 
                            className="link-hover" 
                            title={`${props.SecondLevelDomain} technologies`}
                        >
                            Aggregated View
                        </Link>
                    }
                    {
                        props.TechnologyChangesSummary && 
                        !!(props.TechnologyChangesSummary.TechnologiesAdded ||
                        props.TechnologyChangesSummary.TechnologiesDropped) &&
                        <li>
                            <Link 
                                to={`/website/${props.Domain}/history`}
                                className="link-hover" 
                                title={`Technology stack change history for ${props.Domain}`}
                            >
                                Technology History 
                            </Link><AuthLock />
                        </li>
                    }
                    {
                        !!props.Subdomains.Count &&
                        <li className="word-break">
                            <Link 
                                to={`/website/${props.SecondLevelDomain}/subdomains`} 
                                className="link-hover" 
                                title={`${props.SecondLevelDomain} subdomain list`}
                            >
                                Subdomains 
                            </Link><AuthLock />
                        </li>
                    }
                    {
                        !!props.BackLinks && !!props.BackLinks.DomainCount &&
                        <li>
                            <Link 
                                to={`/website/${props.Domain}/backlinks`} 
                                className="link-hover" 
                                title="List of linking domains and IPs"
                            >
                                Backlinks 
                            </Link><AuthLock />
                        </li>
                    }
                    {
                        !!props.RedirectedFrom.Count &&
                        <li>
                            <Link 
                                to={`/website/${props.Domain}/redirects`} 
                                className="link-hover word-break" 
                                title={`Domains that redirect to ${props.Domain}`}
                            >
                                Domain Forwarding 
                            </Link><AuthLock />
                        </li>
                    }
                    {
                        !!props.IPSharedDomains &&
                        <li>
                            <Link 
                                to={`/ip/${props.IPAddress}/websites`} 
                                className="link-hover" 
                                title={`Reverse IP for ${props.IPAddress}`}
                            >
                                Reverse IP 
                            </Link><AuthLock />
                        </li>
                    }
                    {
                        !!props.Advertisers &&
                        <li>
                            <Link 
                                to={`/website/${props.Domain}/advertisers`} 
                                className="link-hover" 
                                title="List of advertisers used by website"
                            >
                                Advertisers 
                            </Link><AuthLock />
                        </li>
                    }
                </ul>
            </div>
    </>)

}

function Warnings({props}: ComponentProps) {
    
    if (!props.Warnings) return (<></>);
    
    return (<>
    
        <br/>    
        <h4>Security Profile</h4>
        <div>
            <ul>
                {
                    props.Warnings.Offline ?
                    <li>
                        Site is offline{' '}
                        <span className="icon fas fa-exclamation-triangle" style={{color: 'red'}}></span>
                    </li> :
                    <li>
                        Live site{' '} 
                        <span className="icon mdi mdi-checkbox-marked-circle" style={{color: 'green'}}></span>
                    </li> 
                }
                {
                    props.Warnings.AccessViaHTTP ?
                    <li>
                        Site accessed over HTTP{' '} 
                        <span className="icon fas fa-exclamation-triangle" style={{color: 'red'}}></span>
                    </li>:
                    <li>
                        Secure connection (HTTPS){' '} 
                        <span className="icon mdi mdi-checkbox-marked-circle" style={{color: 'green'}}></span>
                    </li>
                }
                {
                    props.Warnings.ExpiredCertificate && !props.Warnings.Unreliable &&
                    <li>
                        Certificate expired on {_printDate(props.Warnings.ExpiredCertificate)}{' '}
                        {
                            props.Warnings.Unreliable ? 
                            <>(Stale)</>
                            :
                            <span className="icon fas fa-exclamation-triangle" style={{color: 'red'}}></span>
                        }
                    </li>
                }
                {
                    props.Warnings.ExpiringCerticate && !props.Warnings.Unreliable &&
                    <li>
                        Certificate is expiring soon on {_printShortDate(props.Warnings.ExpiringCerticate)}{' '}
                        <span className="icon mdi mdi-alarm" style={{color: 'red'}}></span>
                    </li>
                }
                {
                    props.Warnings.ValidCertificate &&
                    <li>
                        Certificate valid{' '}
                        <span className="icon mdi mdi-checkbox-marked-circle" style={{color: 'green'}}></span>
                    </li>
                }
                {
                    props.Warnings.OutdatedTechnologies ?
                    <li>
                        Outdated Techology stack{' '}
                        <span 
                            style={{color: 'red'}} 
                            className="icon fas fa-exclamation-triangle">
                        </span>
                    </li>:
                    <li>
                        No outdated techologies detected
                        <span 
                            className="icon mdi mdi-checkbox-marked-circle" 
                            style={{color: 'green'}}>
                        </span>
                    </li>
                }
            </ul>
        </div>            

    </>)
}
function OutdatedTech({props}: ComponentProps) {
    
    if (!props.Warnings.OutdatedTechnologies) return (<></>);
    
    return (<>
    
        <br/>    
        <h4>Outdated Technologies</h4>
        <div>
            <ul className="list-marked">
                {
                    props.Warnings.OutdatedTechnologies.map((outdatedTech, indexKey) => {
                        return (
                            <li key={indexKey}>
                              {/*    
                                <TechnologyIconAndName 
                                    technology={outdatedTech.Technology}
                                    technologyURL={outdatedTech.TechnologyURL}
                                    technologyIcon={outdatedTech.TechnologyIcon}
                                    title={`${outdatedTech.Technology} customers list, historic trends, and recent website additions`}
                                />
*/}


                               <TechnologyVersionRef technology={outdatedTech} technologyIcon={outdatedTech.TechnologyIcon}/>
                                {' '}
                                <TechnologyVersionWithScore technology={outdatedTech} tooltip='1'/>
                            </li>
                        )
                    })
                }
            </ul>
        </div>            
    </>)
}

function CVEs({props}: ComponentProps) {
    if (!props.DomainCVEs) return (<></>);  
    if (!props.DomainCVEs.length) return (<></>);  
    
    return (<>
    
        <br/>    
        <h4>CVEs</h4>
        <div>
            <ul className="list-marked">
                {
                    props.DomainCVEs.map((cve, indexKey) => {
                        return (
                            <li key={indexKey}>
                                <CVE cve={cve}/>
                            </li>
                        )
                    })
                }
            </ul>
        </div>            
    </>)
}

function CVE(c: {cve?: RtDomainCVE}) {
    if (!c) return (<></>);  
    if (!c.cve) return (<></>);  
    
    let cve = c.cve;
    let title = `${cve.CVEId}`;
    if (cve.CWETitle !== undefined)
    {
        title += ' - ' + cve.CWETitle;
    }
    return (
    <>
        <Link 
            className="link-hover word-break" 
            title={title}
            to={`/cve/${cve.CVEId}`}
        >
            {cve.CVEId}
        </Link>	
    </>);
}

function SocialMediaLink({domain, socialMediaLink}: {domain: string, socialMediaLink: RtSocialMediaLink}) {
    if (!socialMediaLink) return (<></>);

    // TODO: change this to just go through map
    return (<>

            {
                socialMediaLink.Facebook &&
                <p className="word-break">
                    <i title="Facebook account" className="icon text-primary fab fa-facebook-f"> </i>
                    {' '}Facebook:{' '} 
                    {/* No <Link>! this is external reference */}
                    <a 
                        className="link-hover" 
                        title={`${domain} Facebook account`} 
                        rel="noopener nofollow noreferrer" 
                        target="_blank" 
                        href={socialMediaLink.Facebook}
                    >
                        {_extractSocialMediaSlug(socialMediaLink.Facebook)}
                    </a>
                </p>
            }
            {
                socialMediaLink.Twitter &&
                <p className="word-break" >
                    <i title="Twitter account" className="icon text-primary fab fa-twitter"> </i>
                    {' '}Twitter:{' '}
                    {/* No <Link>! this is external reference */} 
                    <a 
                        className="link-hover" 
                        title={`${domain} Twitter account`} 
                        rel="noopener nofollow noreferrer" 
                        target="_blank" 
                        href={socialMediaLink.Twitter}
                    >
                        {_extractSocialMediaSlug(socialMediaLink.Twitter)}
                    </a>
                </p>
            }
            {
                socialMediaLink.Instagram &&
                <p className="word-break">
                    <i title="Instagram account" className="icon text-primary fab fa-instagram"> </i>
                    {' '}Instagram:{' '}
                    {/* No <Link>! this is external reference */} 
                    <a 
                        className="link-hover" 
                        title={`${domain} Instagram account`} 
                        rel="noopener nofollow noreferrer" 
                        target="_blank" 
                        href={socialMediaLink.Instagram}
                    >
                        {_extractSocialMediaSlug(socialMediaLink.Instagram)}
                    </a>
                </p>
            }
            {
                socialMediaLink.Youtube &&
                <p className="word-break">
                    <i title="Youtube channel" className="icon text-primary fab fa-youtube"> </i>
                    {' '}Youtube:{' '}
                    {/* No <Link>! this is external reference */} 
                    <a 
                        className="link-hover" 
                        title={`${domain} Youtube channel`} 
                        rel="noopener nofollow noreferrer" 
                        target="_blank" 
                        href={socialMediaLink.Youtube}
                    >
                        {_extractSocialMediaSlug(socialMediaLink.Youtube)}
                    </a>
                </p>
            }
            {
                socialMediaLink.LinkedIn &&
                <p className="word-break">
                    <i title="Linkedin account" className="icon text-primary fab fa-linkedin"> </i>
                    {' '}Linkedin:{' '}
                    {/* No <Link>! this is external reference */} 
                    <a 
                        className="link-hover" 
                        title={`${domain} Linkedin account`} 
                        rel="noopener nofollow noreferrer" 
                        target="_blank" 
                        href={socialMediaLink.LinkedIn}
                    >
                        {_extractSocialMediaSlug(socialMediaLink.LinkedIn)}
                    </a>
                </p>
            }
    </>)

}


function SocialMediaLinks({props}: ComponentProps) {

    if (!props.SocialMediaLinks) return null;

    return (<>
        <br/>        
        <h4>Social Media</h4>
        <div>
            {
                props.SocialMediaLinks.map((socialMediaLink, indexKey) => {
                    return (
                    <SocialMediaLink 
                        key={indexKey}
                        domain={props.Domain}
                        socialMediaLink={socialMediaLink}
                    />)
                })
            }
        </div>
    </>)
}
function ContactInfo({props}: ComponentProps): null {

    // TODO: temporary hide contact info untill we have better data
    return null;

    // if (!props.ContactInfo.HasContactInfo) return null;

    // return (<>
    //     <br/>    
    //     <h4>Contact Info</h4>
    //     <div>
    //         {
    //             props.ContactInfo.Phone &&
    //             <p>
    //                 <span className="icon text-primary mdi mdi-cellphone"> </span>
    //                 Phone: {props.ContactInfo.Phone}
    //             </p>
    //         }
    //         {
    //             props.ContactInfo.Fax &&
    //             <p>
    //                 Fax: {props.ContactInfo.Fax}
    //             </p>
    //         }
    //         {
    //             props.ContactInfo.Email &&
    //             <p>
    //                 <span className="icon text-primary mdi mdi-email"> </span>
    //                 Email: {props.ContactInfo.Email}
    //             </p>
    //         }
    //     </div>
    // </>)
}

function Address({props}: ComponentProps) {

    if (!props.ContactInfo.HasAddress) return null;

    return (<>
        <br/>
        <h4>Address</h4>
        <div>
           <p>
                <span className="icon text-primary mdi fa-address-card-o"> </span>           
                &nbsp;{props.ContactInfo.Address}
            </p>
        </div>
    </>)
}

function Subdomains({props}: ComponentProps) {

    return (<>
        <br/>
        <h4>Subdomains</h4>
        <div>
            {
                props.Subdomains.Count > 0 ?
                <>
                    <ul>      
                    {
           
                        props.Subdomains.Domains.map((subdomain, indexKey) => {
                            return (
                                // TODO Move delayedload images into a component

                                    <li key={indexKey}>
                                        <DomainIcon domain={subdomain}/>
                                        {' '}
                                        <Link 
                                            to={`/website/${subdomain}`} 
                                            className="link-hover word-break" 
                                            title={`${subdomain} information and technology stack`}
                                        >
                                            {subdomain}
                                        </Link>
                                    </li>

                            )
                        })                        
                    }
                    </ul>  
                    {
                        props.Subdomains.MoreThan10 &&
                        <>
                            <br/>
                            <li>
                                <Link 
                                    to={`/website/${props.SecondLevelDomain}/subdomains`} 
                                    className="link-hover" 
                                    title={`${props.SecondLevelDomain} subdomain list`}
                                > 
                                    ... See all {props.Subdomains.Count} 
                                </Link><AuthLock />
                            </li>
                        </>
                    }
                </>:
                <>
                No subdomains
                </>
            }  
        </div>
    </>)
}

function Keywords({props}: ComponentProps) {

    if (!props.Keywords) return null;

    return (<>
          
        <br/>  
        <h4>Keywords</h4>
        <br/>
        <div>
            <ul>
            {
                props.Keywords.map((keyword: string, indexKey: number) => 
                    <li key={indexKey}>
                        {keyword}
                    </li>
                )
            }
            </ul>
            <br/>
        </div>
    </>)

}

function Tags({props}: ComponentProps) {

    if (!props.Tags) return null;

    return (<>
         
        <br/>
        <h4>Tags</h4>
        <div>
            <ul>
            {
                props.Tags.map((tag: string, indexKey: number) => 
                    <li key={indexKey}>
                        <Link 
                            to={`/tag/${tag}`} 
                            className="link-hover" 
                            title={`Websites using tag id ${tag}`}
                        > 
                            {tag}
                        </Link>
                    </li>
                )
            }
            </ul>
        </div>
    </>)

}

function WebsiteRightPanel({props}: ComponentProps) {

    return (<>
        <article className="box-bordered">
            <AvailableReports props={props}/>
            <LastCrawledDate props={props}/>    
            <ActionButtons props={props} />
            <Warnings props={props}/>
        {/**   <CVEs props={props}/>*/}  
            <OutdatedTech props={props}/>
            <Address props={props}/>
            <ContactInfo props={props}/>
            <SocialMediaLinks props={props}/>
            <Tags props={props}/>            
            <Subdomains props={props}/>
            <Keywords props={props}/>

        </article>
    </>)

}

function SimilarDomains({similarDomains}: {similarDomains?: unknown[]}) {

    return (<></>);
    // if (!similarDomains) return null;
    // return (<>
    
    //     <div className="row row-50">
    //         <div className="col-12">
    //             <h3 className="text-left">Website that use similar tech stack</h3>
    //             <br/>
    //             <br/>
    //             <div className="table-outer table-rounded table-responsive-lg">
    //                 <table className="table-custom table-custom-striped table-custom-primary  ">
    //                     <thead>
    //                         <tr>
    //                             <th style={{width: '30%'}}>Domain</th>
    //                             <th style={{width: '25%'}}>Country</th>
    //                             <th style={{width: '15%'}}>Rank</th>
    //                             <th style={{width: '15%'}}>Similarity</th>
    //                             <th style={{width: '15%'}}>Common Technologies</th>
    //                         </tr>
    //                     </thead>
    //                     <tbody>
    //                         {
    //                             similarDomains.map((similarDomain: unknown, indexKey: number) =>
    //                                 <SimilarDomain key={indexKey} similarDomain={similarDomain}/>
    //                             )
    //                         }
    //                     </tbody>
    //                 </table>
    //             </div>
    //         </div>
    //     </div>
    //     <br/>
    //     <br/>
    // </>)
}

function SimilarDomain({similarDomain}: {similarDomain: unknown}): null {

    return null;

    // return (<>
 
    //     <tr>
    //         <td>
    //             <Link 
    //                 to={`/website/${similarDomain.Domain}`}
    //                 title={`${similarDomain.Domain} technology stack and statistics`} 
    //             >
    //                 {similarDomain.Domain}
    //             </Link>
    //         </td>
    //         <td>
    //             <CountryFlagAndName countryCode={similarDomain.Country} />
    //         </td>
    //         <td>{_printDomainRank(similarDomain.Rank)}</td>
    //         <td>{_printPercent(similarDomain.Similarity)}%</td>
    //         <td>{similarDomain.CommonTechnologies}</td>
    //     </tr>
    // </>)
}

function DomainHeaders({responseHeaders, link}: {responseHeaders: RtResponseHeadersSection, link: string}) {

    if (!responseHeaders.Headers) return null;

    return (<>
    
            <div className="row row-50">
                <div className="col-12">
                    <SectionHeader header={responseHeaders.Header}  link={link} anchor='headers'/>
                    <div className="table-outer table-rounded table-responsive-lg">
                        <table className="table-custom table-custom-striped table-custom-primary"
                               style={{tableLayout: 'fixed', width: '100%'}}>
                            <thead>
                                <tr>
                                    <th style={{width: '30%'}}>Header</th>
                                    <th style={{width: '70%'}}>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    responseHeaders.Headers.map((header, indexKey) => 
                                        <ResponseHeader header={header} key={indexKey}/>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
    </>);

}

function ResponseHeader({header}: {header: RtHeaderInfo}) {
    
    return (
        <tr>
            <td style={{wordWrap: 'break-word'}}>
                <Link 
                    to={`/response-header/${header.HeaderMoniker}`}
                    className="link-hover" 
                    title={`${header.Header} response header`} 
                >
                    {header.Header}
                </Link>
            </td>
            <td style={{wordWrap: 'break-word'}}>
                {header.Value}
            </td>
        </tr>
    )
}


function WebsiteBottomPanel({props}: ComponentProps) {

    return (<>
        <DomainTechnologies technologies={props.Technologies} link={props.CanonicalURL} anchor='anchor' /*merge={true}*/ />
        <DomainHistory technologyChanges={props.TechnologyChanges} link={props.CanonicalURL}/>
        <DomainTechnologies  technologies={props.Advertisers!} link={props.CanonicalURL} anchor='advertisers'/>
        <SimilarDomains similarDomains={props.SimilarDomains}/>
        <DomainHeaders responseHeaders={props.ResponseHeaders} link={props.CanonicalURL!}/>
    </>)

}

function LastCrawledDate({props}: ComponentProps) {

    if (!props.LastCrawledDate) return null;

    return (
        <>
            <br/>
            <h4>Last Update</h4>         
            <div>
                {_printDate(props.LastCrawledDate)}              
            </div>
        </>
    )
}

function ActionButtons({props}: ComponentProps) {
//"button button-secondary"
    return (<>
    <br/>
    <h4>Scan & Monitor</h4>              
    <br/>
    <div >
        <Link                     
            to={`/cve-security-scan?website=${props.Domain}`}
            className="btn btn-primary btn-sm" 
            title={`Scan website`} 
            rel="noopener nofollow" 
        >
            Security Scan
        </Link>     
    </div>
    <br/>
    <div>
        <Link                     
            to={`/technology-scan?website=${props.Domain}`}
            className="btn btn-primary btn-sm" 
            title={`Scan website`} 
            rel="noopener nofollow" 
        >
            Live Scan
        </Link>     
    </div>  <br/>
    <div>
        <Link                     
            to={`/monitoring/add-website?website=${props.Domain}`}
            className="btn btn-primary btn-sm" 
            title={`Monitor website`} 
            rel="noopener nofollow" 
        >
            Monitor website
        </Link>
    </div>   
    </>);     
}

function TagId({tag, index}: {tag: string, index: number}) {
    if (!tag) return null;

    return (
        <>
            {
                0 !== index &&
                <>, </>
            }    
            <Link
                to={`/tag/${tag}`} 
                className="link-hover" 
                title={`Websites using tag id ${tag}`}
                > 
                <b>{tag}</b>
            </Link>         
        </>   
    )
}


function SecurityStats({cves, link}: {cves?: RtDomainCVE[], link: string}) {

	if (!cves) return null;
	if (cves.length === 0) return null;

	return (
		<>

	<div className="row row-50">
		<div className="col-12">   
		<h3 id="vulnerabilites">Security vulnerabilites
		<CopyLink link={link}  anchor='vulnerabilites'/> 
		</h3>    
		<br/>    
		<div className="table-outer table-rounded table-responsive-lg">
			<table className="table-custom table-custom-striped table-custom-primary  ">
					<thead>
					<tr>
                        <th style={{width: '15%'}}>CVE</th> 
                        <th style={{width: '50%'}}>Title</th> 
                        <th style={{width: '35%'}}>Technology</th> 
					</tr>
					</thead>
							<tbody>
									{
									cves.map((cve, indexKey) => {
											return (
												<CVERow cve={cve} key={indexKey}/>
											)
									})
							}	
					</tbody>
			</table>
		</div>		
		</div>		
	</div>		
		</>
	)
}

function CVERow({cve, requireAuthentication}: {cve: RtDomainCVE, requireAuthentication?: boolean}) {
	// icon, tech, version, category, date, count
	return (
		<>
			<tr>           
				<td>
					{cve.CVEId}
				</td>    
			<td>	       
				{/* inconcistency in CVEId naming -with or without CVE prefix* */}              
					<Link 
							to={`/cve/${cve.CVEId}`} 
							className="link-hover" 
					>
						<CveTitle cve={cve} />
					</Link> 							
			</td>				
            <td>
				{cve.Technology} {cve.Version}
			</td> 
			</tr>		
		</>
	)
}
	